<div class="person-citations__wrapper" #scrollContainer>
  <div *ngIf="loading" class="loading">
    <mat-spinner/>
  </div>
  <div *ngIf="!loading"
       [className]="'person-citations ' + (fullScreenChart? ('fullscreen-mode__'+fullScreenChart): '')">
    <div class="person-citations__by-race">
      <app-card [name]="chartTitles.RACE_ETHNICITY" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('0')">
        <app-by-race-chart
          #raceChart
          [generateData]="generateRaceData"
          [selections]="selections"
          [name]="raceChartName"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, raceChartName)"
        ></app-by-race-chart>
      </app-card>
    </div>
    <div class="person-citations__by-gender">
      <app-card [name]="chartTitles.CITATIONS_BY_GENDER" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('1')">
        <app-pie-chart
          #genderChart
          beforeTitleTooltip="Sex"
          titleTooltip="Citations Count"
          [name]="genderChartName"
          [generateData]="generateGenderData"
          [options]="genderChartOptions"
          [isFullScreen]="fullScreenChart!==null"
          [selections]="selections"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, genderChartName)"
        ></app-pie-chart>
      </app-card>
    </div>
    <div class="person-citations__by-contraband">
      <app-card [name]="chartTitles.CONTRABAND_OR_EVIDENCE" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('2')">
        <app-pie-chart
          #contrabandChart
          beforeTitleTooltip="Contraband"
          titleTooltip="Count of Citation"
          [name]="contrabandChartName"
          [generateData]="generateContrabandData"
          [options]="contrabandChartOptions"
          [isFullScreen]="fullScreenChart!==null"
          [selections]="selections"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, contrabandChartName)"
        ></app-pie-chart>
      </app-card>
    </div>
    <div class="person-citations__by-reason-for-stop">
      <app-card [name]="chartTitles.REASON_FOR_STOP" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('3')">
        <app-pie-chart
          #reasonStopChart
          beforeTitleTooltip="ReasonStop"
          titleTooltip="Count of Citation"
          [name]="reasonForStopChartName"
          [generateData]="generateReasonForStopData"
          [options]="reasonForStopChartOptions"
          [isFullScreen]="fullScreenChart!==null"
          [selections]="selections"
          [isFullScreen]="fullScreenChart!==null"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, reasonForStopChartName)"
        ></app-pie-chart>
      </app-card>
    </div>
    <div class="person-citations__by-reason-for-search">
      <app-card [name]="chartTitles.REASON_FOR_SEARCH" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('4')">
        <app-pie-chart
          #reasonSearchChart
          beforeTitleTooltip="Search"
          titleTooltip="Count of Citation"
          [name]="reasonForSearchChartName"
          [generateData]="generateReasonForSearchData"
          [options]="reasonForSearchChartOptions"
          [isFullScreen]="fullScreenChart!==null"
          [selections]="selections"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, reasonForSearchChartName)"
        ></app-pie-chart>
      </app-card>
    </div>
    <div class="person-citations__by-result-of-stop-chart">
      <app-card [name]="chartTitles.RESULT_OF_STOP" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('5')">
        <app-pie-chart
          #resultStopChart
          beforeTitleTooltip="ResultStop"
          titleTooltip="Count of Citation"
          [name]="resultOfStopChartName"
          [generateData]="generateResultOfStopData"
          [options]="resultOfStopChartOptions"
          [isFullScreen]="fullScreenChart!==null"
          [selections]="selections"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, resultOfStopChartName)"
        ></app-pie-chart>
      </app-card>
    </div>
    <div class="person-citations__by-age">
      <app-card [name]="chartTitles.CITATIONS_BY_AGE_GROUP" [isFullScreen]="fullScreenChart!==null"
                (buttonClicked)="toggleFullScreen('6')">
        <app-pie-chart
          #ageChart
          beforeTitleTooltip="Minor"
          titleTooltip="Count of Citation"
          [name]="ageGroupChartName"
          [generateData]="generateAgeGroupData"
          [options]="ageGroupChartOptions"
          [isFullScreen]="fullScreenChart!==null"
          [selections]="selections"
          (setSelections)="setSelections($event.newFilters, $event.resetOther, ageGroupChartName)"
        ></app-pie-chart>
      </app-card>
    </div>
  </div>
</div>
